import { useTranslation } from 'react-i18next';

/**
 * Required by Art. 50 Abs. 1 KI-VO: users interacting with an AI system must be made aware of
 * that before/at the first interaction. Mount once per chat shell, directly under the latest
 * message (not per app, not per message) - see TASKS.md, "KI-Kennzeichnung".
 */
export const AiDisclosureNotice = () => {
    const { t } = useTranslation('common');
    return (
        <div className="small text-secondary mt-1 mb-2">
            {t('ai.disclosure')}
        </div>
    );
};
